import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';

const CIFailPopup: FC = () => {
  const store = useContext(NolPromotionStoreCtx);

  return (
    <Popup
      isOpen={store.isCIFailPopupOpen}
      mainBtn={{
        label: '닫기',
        onClick: () => (store.isCIFailPopupOpen = false),
      }}
    >
      {{ title: '인증 정보를 가져오는데 실패하였습니다.\n잠시 후 다시 시도해주세요.' }}
    </Popup>
  );
};

export default observer(CIFailPopup);
